var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"value":_vm.show,"position-x":_vm.positionX,"position-y":_vm.positionY,"top":""}},_vm._l((_vm.text),function(line){return _c('p',{style:({ color: _vm.color })},[_vm._v("\n    "+_vm._s(line)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }